<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table :items="userList" :headers="headers">
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Lista Utenti</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Nuovo Utente
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">Utente</span>
                      </v-card-title>

                      <v-card-text>
                        <v-alert
                          border="left"
                          color="red"
                          type="error"
                          v-if="errorString"
                          v-html="errorString"
                        ></v-alert>
                        <v-container>
                          <v-row>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="editedItem.name"
                                label="Nome *"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-select
                                :items="roles"
                                v-model="editedItem.role"
                                label="Ruolo"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-select
                                :items="companies"
                                v-model="editedItem.selected_shop"
                                label="Company"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-select
                                :items="pointOfSale"
                                item-value="US_MAGAZZINO"
                                item-text="TB_DESSTAB"
                                v-model="editedItem.shop_owner"
                                label="Negozio"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="editedItem.email"
                                label="Email *"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="editedItem.password"
                                label="Password"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="editedItem.password_confirmation"
                                label="Ripeti Password"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                          Annulla
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="600px">
                    <v-card>
                      <v-card-title class="text-h5"
                        >Eliminare questo utente?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete"
                          >Annulla</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      color="success"
      absolute
      center
      top
      >{{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>
<style lang="scss"></style>
<script>
import requests from "../requests";
import helpers from "../helpers";
export default {
  name: "users",
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  data: () => {
    return {
      snackbar: false,
      snackbarText: "",
      errorString: null,
      roles: ["Admin", "Negozio Franchising", "Negozio Diretto", "Dipendente Franchising", "Solo Prodotti"],
      companies: [
        {
          value: "J",
          text: "Jacob",
        },
        {
          value: "A",
          text: "Attilia",
        },
      ],
      pointOfSale: [],
      userList: [],
      editedItem: {
        id: 0,
        name: "",
        email: "",
        role: "Negozio",
      },
      defaultItem: {
        id: 0,
        name: "",
        email: "",
        role: "Negozio",
      },
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Nome", value: "name" },
        { text: "Email", value: "email" },
        { text: "Ruolo", value: "role" },
        { text: "Company", value: "selected_shop" },
        { text: "Azioni", value: "actions", sortable: false },
      ],
    };
  },
  mounted() {
    console.log("Product Mounted.");
    this.loadUserList();
    requests.getPointOfSales().then((res) => {
      this.pointOfSale = res.data;
    });
  },
  methods: {
    loadUserList() {
      requests.getUserList().then((res) => {
        this.userList = res.data;
      });
    },

    saveUser(item) {
      requests.saveUser(item).then((res) => {
        if (!_.isUndefined(res.response)) {
          this.errorString = helpers.formatAjaxError(res.response.data);
        } else {
          this.close();
          this.loadUserList();
          this.snackbarText = "Utente SALVATO con successo";
          this.snackbar = true;
        }
      });
    },

    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      requests.deleteUser(this.editedItem.id).then((res) => {
        if (!_.isUndefined(res.response)) {
          this.errorString = helpers.formatAjaxError(res.response.data);
        } else {
          this.closeDelete();
          this.loadUserList();
          this.snackbarText = "Utente ELIMINATO con successo";
          this.snackbar = true;
        }
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.errorString = "";
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    save() {
      console.log(this.editedItem);
      this.saveUser(this.editedItem);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.errorString = "";
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>
